export const DESKTOP_BANNER_HEIGHT = '30px';
export const DESKTOP_BANNER_HEIGHT_NUMERIC = 30;

export const MOBILE_BANNER_HEIGHT = '40px';
export const MOBILE_BANNER_HEIGHT_NUMERIC = 40;

export const BANNER_SLUG = 'web-cta-banner';
